<template>
    <div class="invoiceRegBox">
        <div class="invoiceRegTab">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="注册信息" name="1">
                    <register-info ref="registerInfoRef" @dataLoad="handleDataLoad"></register-info>
                </el-tab-pane>
                <el-tab-pane label="项目信息" name="2">
                    <goods-info ref="goodsInfoRef" :jobId="jobId" ></goods-info>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import RegisterInfo from './components/RegisterInfo/index.vue';
import GoodsInfo from './components/GoodsInfo/index.vue';
export default {
    name: 'InvoiceRegistration',
    components: { RegisterInfo, GoodsInfo },
    data() {
        return {
            activeName: '1',
            jobId: ''
        };
    },
    computed: {
        hasRegisterInfo: function () {
            return !!this.$refs.registerInfoRef.jobId;
        }
    },
    methods: {
        handleClick() {
            if (this.activeName === '2') {
                this.$nextTick(() => {
                    this.$refs.goodsInfoRef.queryList();
                });
            }
        },

        handleDataLoad(jobId) {
            this.$nextTick(() => {
                this.jobId = jobId;
            });
        }
    }
};
</script>

<style lang="less">
@import "../../../styles/common.less";
@import "./invoiceRegistration.less";
</style>